module.exports = __webpack_public_path__ + "static/assets/7660df4a09eaa2f7b56f0bd75a951a0b.svg";